import React from 'react';

const MonthlyPrice = props => {
  return (
    <div className="MonthlyPriceContainer" >
        
        <div className="MonthlyPrice" >
          税抜
          <span className="MonthlyPriceValue">{props.price}</span>
          
          <div className="MonthlyPriceCurrency" >
            円
          </div>
        </div>
        <div className="MonthlyPriceTax" >
          (税込 <span className="MonthlyPriceTaxValue">{props.priceWithTax}</span><span className="MonthlyPriceTaxCurrency">円 </span>)
        </div>        
    </div>
  );
};

export default MonthlyPrice;
